import Dropkick from 'dropkickjs';

const moduleName = 'customSelect';

export function customSelect() {

    Array.from(document.querySelectorAll('.js-custom-select')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const select = self;
        const selectOptions = select.querySelectorAll('option');
        const $select = $(select);
        const customSelect = new Dropkick(select, {
            mobile: false,
            change: () => {
                const form = select.closest('form[data-parsley-validate]');

                select.closest('.js-placeholder').classList.add('_filled');

                if (form) $select.parsley().validate();
            },
            initialize: () => {
                Array.from(selectOptions).forEach((selectOption) => {
                    const notice = selectOption.dataset.notice;

                    if (!notice) return;

                    setTimeout(() => {
                        const $customSelect = $select.prev('.js-custom-select');
                        const $customSelectOption = $customSelect.find('[data-value="' + selectOption.value + '"]');

                        $customSelectOption[0].dataset.notice = notice;
                    }, 10);
                });
            }
        });

        $select.parsley().on('field:validate', () => {
            const $customSelect = $select.prev('.js-custom-select');

            if (!$customSelect.length) return;

            if ($select.parsley().isValid()) {
                $customSelect.removeClass('_error');
            } else {
                $customSelect.addClass('_error');
            }
        });
    });

}